import i18n from 'i18next'
import { readOptions, TranslationOptions } from './translationOptions'

// Like i18next, a string as second argument is the default value: t(key, 'Fallback')
type TranslationParams = {} | string

const mergeOptions = (params?: TranslationParams): TranslationOptions => {
    const { showKeys, ...resolutionOptions } = readOptions()

    if (params === undefined) {
        return resolutionOptions
    }

    return typeof params === 'string'
        ? { ...resolutionOptions, defaultValue: params }
        : { ...resolutionOptions, ...params }
}

export const translatePlain = (key: string, params?: TranslationParams): string => i18n.t(key, mergeOptions(params))

export const translateOrNull = (key: string, params?: TranslationParams): string | null => {
    const result = translatePlain(key, params)

    return result === key ? null : result
}

export const translateForDisplay = (key: string, params?: TranslationParams): string => {
    const resolutionOptions = mergeOptions(params)
    const text = i18n.t(key, resolutionOptions)

    if (readOptions().showKeys !== true) {
        return text
    }

    const { context } = resolutionOptions
    const hasContext = typeof context === 'string' && context !== ''
    const contextKey = hasContext ? `${key}_${context}` : null
    const resolvedKey = contextKey !== null && i18n.exists(contextKey, resolutionOptions) ? contextKey : key

    return text === resolvedKey ? text : `${text} [${resolvedKey}]`
}
